import * as actions from './actions';
import { selectDialogs } from './selectors';
import { AddDialogProps, Dialog, DialogPropMap } from './types';

export const closeDialog = (type: Dialog) => {
  window.top!.store.dispatch(actions.closeDialog(type));
};

export const closeAllDialogs = () => {
  window.top!.store.dispatch(actions.closeAllDialogs());
};

export const addDialog = <T extends Dialog>(type: T, props: AddDialogProps<DialogPropMap[T]>) => {
  window.top!.store.dispatch(actions.addDialog(type, props));

  return () => {
    closeDialog(type);
  };
};

export const hasOpenDialogs = () => {
  return selectDialogs(window.top!.store.getState()).length > 0;
};

export const hasOpenDialog = (type: Dialog) => {
  return selectDialogs(window.top!.store.getState()).some((dialog: { type: Dialog }) => dialog.type === type);
};
